/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';
import React, { Component } from 'react';

import { refreshToken } from '../../api/session';

export interface UserActivityMonitorProps {
  enabled: boolean;
  interval: number;
}

class UserActivityMonitor extends Component<UserActivityMonitorProps> {
  static defaultProps = {
    enabled: false,
    interval: 60000
  };

  componentDidMount() {
    if (this.props.enabled) {
      this.setupActivityMonitor();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.enabled && !this.props.enabled) {
      this.teardownActivityMonitor();
    }
  }

  componentWillUnmount() {
    if (this.props.enabled) {
      this.teardownActivityMonitor();
    }
  }
  render() {
    return <div className="UserActivityMonitor" />;
  }

  activeCallback = _.throttle(refreshToken, this.props.interval, {
    trailing: false
  });

  setupActivityMonitor = () => {
    window.addEventListener('mousedown', this.activeCallback, {
      capture: true
    });
    window.addEventListener('keypress', this.activeCallback, { capture: true });
  };

  teardownActivityMonitor = () => {
    window.removeEventListener('mousedown', this.activeCallback, {
      capture: true
    });
    window.removeEventListener('keypress', this.activeCallback, {
      capture: true
    });
    this.activeCallback.cancel();
  };
}

export default UserActivityMonitor;
